import { Header } from "src/apps/components/header/Header";
import { BaseScreen } from "../../components/baseScreen/BaseScreen";

import { OTPForm } from "./components/OTPForm";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/apps/hooks/useAuth";
import { CenteredContainer } from "./components/CenteredContainer";
import { MagicLinkParkingContainer } from "./components/MagicLinkParkingContainer";
import { useGetCustomerCustomization } from "../../hooks/useGetCustomization";
import { LoadingScreen } from "../../components/loading/LoadingScreen";
import { LoginTypes } from "../../../contexts/auth/application/AuthController";
import { colors } from "@permisso/permisso-components";

export const TwoFactorScreen = () => {
  const navigate = useNavigate();
  const { loginEmail } = useAuth();
  const { data: customization, isLoading } = useGetCustomerCustomization();
  const [loginType, setLoginType] = useState(LoginTypes.EMAIL_CODE);

  useEffect(() => {
    if (!loginEmail) navigate(-1);
    const loginType = customization?.documentationAreaLoginMethod;
    if (loginType) setLoginType(loginType);
  }, [customization]);

  if (isLoading) return <LoadingScreen />;

  return (
    <BaseScreen
      backgroundColor={colors.grey0}
      header={<Header />}
      screenPadding="32px"
      mobileScreenPadding="20px"
    >
      <CenteredContainer>
        {loginType === LoginTypes.EMAIL_CODE ? <OTPForm /> : <MagicLinkParkingContainer />}
      </CenteredContainer>
    </BaseScreen>
  );
};
